<div *ngIf="authService.isUserInCompanyWithModule('AnalyticsAndBI')" class="aar-analytics-bi aar-page">
  <div class="content">
    <div class="iframeContainer" [innerHTML]="domoEmbedUrl | safe: 'html'"></div>
  </div>
</div>
